import { render, staticRenderFns } from "./VSelectPeriod.vue?vue&type=template&id=2280ddb2&"
import script from "./VSelectPeriod.vue?vue&type=script&lang=js&"
export * from "./VSelectPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2280ddb2')) {
      api.createRecord('2280ddb2', component.options)
    } else {
      api.reload('2280ddb2', component.options)
    }
    module.hot.accept("./VSelectPeriod.vue?vue&type=template&id=2280ddb2&", function () {
      api.rerender('2280ddb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectPeriod.vue"
export default component.exports